<template>
    <div v-if="loaded" class="grade_item-container">
        <h2 class="grade_item-name">График активности студентов</h2>
        <div class="chart">
            <apexchart type="line" height="460" :options="options" :series="series"></apexchart>
        </div>
    </div>
</template>

<script>
import apexchart from 'vue-apexcharts';
import { mapGetters } from 'vuex';

export default {
    name: 'ActivityByMonth',
    components: { apexchart },
    data: () => ({
        options: {
            legend: {
                showForSingleSeries: true,
                markers: {
                    strokeColor: '#717BF9',
                    radius: 12
                }
            },
            stroke: {
                colors: '#717BF9'
            },
            chart: {
                toolbar: {
                    show :false
                },
                width: '100%'
            },
            dataLabels: {
                enabled: false
            },
            yaxis: {
            },
            xaxis: {
                categories: []
            },
            fill: {
                opacity: 1
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return  val;
                    }
                },
            }
        },
        series: [{
            name: 'Количество входов в систему',
            data: []
        }],
        loaded: false
    }),
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl'
        })
    },
    methods: {
        load(filters) {
            this.loaded = false;

            this.$http.post(`${this.apiUrl}Student/GetActivityByMonth`, { filters: filters })
                .then((result) => {
                    this.options.xaxis.categories = [];
                    this.series[0].data = [];

                    result.data.data.forEach(x => {
                        this.options.xaxis.categories.push(x.name);
                        this.series[0].data.push(x.count);
                    });

                    this.loaded = true;
            });
        }
    }
}
</script>
